
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { first, switchMap, take } from 'rxjs/operators';
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';

import { KycComponent } from '../kyc/kyc.component';
import { OtpverificationComponent } from '../otpverification/otpverification.component';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']


})

export class ProfileComponent implements OnInit {
  isLoggedIn = false;
  public edit: boolean = false;
  currentUser: any;
  username?: string;
  servicename?: string;
  MobileNo: any;
  IsdCode: any;
  EmailId: any;
  submitted = false;

  serviceId: any;
  ServiceCountryList: any;
  mobileotpstatus: any;
  kycstatus: any;
  emailConfirmed: any;
  profileImage: any;
  editProfileDetail: FormGroup;
  cardImage: any;
  companyname: any;
  withdrawallimit: any;

  constructor(private fb: FormBuilder, private toastr: ToastrService, private tokenStorageService: TokenStorageService, public dialog: MatDialog,
    private authService: AuthService, private _service: AuthenticationService, public dialogRef: MatDialogRef<ProfileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private ref: ChangeDetectorRef, private tokenService: AuthenticationService) {
    this.editProfileDetail = this.fb.group({
      FirstName: [null, [Validators.required, Validators.maxLength(15)]],
      LastName: [null, [Validators.required, Validators.maxLength(15)]]
    })
  }


  ngOnInit(): void {


    this.edit = false;
    //this.isLoggedIn = !!this.tokenStorageService.getToken();

    //if (this.isLoggedIn) {

    this.currentUser = this.tokenStorageService.getUser();

    if (this.currentUser.profileImage != null) {

      this.profileImage = this.currentUser.profileImage;
    }
    else {
      this.profileImage = '../../../../../assets/Images/default_pic.png';
    }


    //this.getServiceCountryList(this.currentUser.serviceProvider1); //further use for dropdown list 
    // }
    //this.tokenStorageService.cc.subscribe(value => {
    //  
    //  this.serviceIdVal = value;
    //});
    
     // this.getcompanyname();
    

  }

  get f() { return this.editProfileDetail.controls; }
  //f&l name post change request
  editUserProfile(val: any) {

    if (val == 1) {
      this.edit = true;
    }

    else {
      this.edit = false;
    }
  }

  getcompanyname() {

    this.authService.getcompanyname().subscribe(
      (response: { apiStatus: any; apiData: any; }) => {

        //this.companyname = response.apiData.companyname;
        //this.withdrawallimit = response.apiData.wiwithdrawallimit;
      }, (err: any) => {
        this.toastr.error(err.error, 'Error');
      });
  }

  getServiceCountryList(serviceIdVal: any) {

    this.authService.getServiceCountryList().subscribe(
      (response: { isSuccess: any; result: any; }) => {

        this.ServiceCountryList = response;
        var d = this.ServiceCountryList.filter((x: { serviceId: any; }) => x.serviceId == serviceIdVal)[0];
        this.serviceId = d.serviceProvider;
      }, (err: any) => {
        this.toastr.error(err.error, 'Error');
      });
  }

  openOtpDialog() {

    const dialogRef = this.dialog.open(OtpverificationComponent, {
      data: {
        MobileNo: this.MobileNo, IsdCode: this.IsdCode
      },
      width: '950px',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== null && result) {
      }
    });
  }

  openKycDialog() {
    const dialogRef = this.dialog.open(KycComponent, {
      width: '950px',
      maxHeight: '90vh',
      data: null

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== null && result) {
      }
    });
  }


  updateProfile(post: any) {

    this.submitted = true;

    post.EmailId = this.currentUser.email;

    if (this.editProfileDetail.valid) {
      this.authService.ChangeFirstLastName(post).subscribe((response: { apiStatus: any; apiMessage: any; }) => {

        if (response.apiStatus == true) {
          this.toastr.success(response.apiMessage, 'Success');
          this.tokenService.updateMessagetoken('token');
          this.dialogRef.close(true);
        } else {
          this.toastr.error(response.apiMessage, "Error");
        }

      }, (err: any) => {
        this.toastr.error(err.error, "Error");
      }
      );
    }
  }


  preview(files: any) {

    if (files.length === 0) {
      this.toastr.error('No file', 'Error');
      return;
    }
    if (files[0].type === 'image/jpeg' || files[0].type === 'image/png' || files[0].type === 'image/jpg') {
      // if (event.target.files[0].size < 200 * 200) {/* Checking height * width*/ }
      // if (event.target.files[0].size < 2000000) {/* checking size here - 2MB */ }


      this.cardImage = files[0];
      this.profileImage = '';

      const formdata: FormData = new FormData();


      formdata.append("Image", this.cardImage);
      formdata.append("Username", this.currentUser.userName);

      this.authService.UploadProfileImage(formdata).subscribe(response => {

        this.cardImage = '';
        if (response.apiData != null) {
          this.profileImage = response.apiData;
          this.tokenService.updateMessagetoken('token');

        }
        else {

          this.profileImage = '../../../../../assets/Images/default_pic.png';

        }
        if (response.apiStatus == true) {
          this.toastr.success(response.apiMessage, 'Success');
        } else {
          this.toastr.error(response.apiMessage, 'Error');
        }
      }, (err: any) => {
        if (err.error instanceof Error) {
          this.toastr.error(err.error, 'Error');
        } else {
          this.toastr.error(err.error, 'Error');
        }
      });

    }
    else {
      this.toastr.error('Only images are supported.', 'Error');
      return;
    }

  }

}
